"use client";

import { JURISDICTIONS } from "@/lib/constants";

export default function Header({
  activeView,
  activeJur,
  setActiveJur,
  totalArticles,
  lastFetchDate,
  storedArticles,
  storageLoaded,
  onFetch,
  searchBusy,
  loading,
  classifying,
  saving,
}) {
  const activeJurData = JURISDICTIONS.find((j) => j.id === activeJur);
  const jurColor = activeJurData?.color || "#FF5D31";

  return (
    <header
      style={{
        backgroundColor: "#fff",
        borderBottom: "1px solid #999",
        padding: "24px 28px 0",
      }}
    >
      <div style={{ maxWidth: "900px", margin: "0 auto" }}>
        {/* Row 1: Title left, stats right */}
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            marginBottom: "20px",
            flexWrap: "wrap",
            gap: "12px",
          }}
        >
          <h1
            style={{
              margin: 0,
              fontSize: "26px",
              fontFamily: "var(--font-serif)",
              fontWeight: 700,
              color: "#1B1B1A",
            }}
          >
            CJJ Regional Media <em style={{ fontWeight: 400, color: jurColor }}>Tracker</em>
          </h1>
          <p
            style={{
              margin: 0,
              fontSize: "13px",
              fontFamily: "var(--font-sans)",
              color: "#999999",
              alignSelf: "center",
            }}
          >
            {storageLoaded ? `${totalArticles} articles stored` : "Loading\u2026"}
            {" \u00B7 "}Last fetch: {lastFetchDate}
          </p>
        </div>

        {/* Row 2: Jurisdiction tabs left, search buttons right */}
        <div
          style={{
            display: "flex",
            alignItems: "flex-end",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: "8px",
          }}
        >
          <nav style={{ display: "flex", gap: "0" }}>
            {JURISDICTIONS.map((jur) => {
              const isActive = activeJur === jur.id;
              const count =
                storedArticles[jur.id]?.filter((a) => a.classification?.relevant).length || 0;
              return (
                <button
                  key={jur.id}
                  onClick={() => setActiveJur(jur.id)}
                  style={{
                    padding: "10px 20px 12px",
                    border: "none",
                    borderBottom: isActive
                      ? `3px solid ${jur.color}`
                      : "3px solid transparent",
                    backgroundColor: "transparent",
                    color: isActive ? jur.color : "#999999",
                    fontSize: "14px",
                    fontFamily: "var(--font-serif)",
                    fontWeight: isActive ? 600 : 400,
                    cursor: "pointer",
                  }}
                >
                  {jur.name}
                  <span
                    style={{
                      marginLeft: "6px",
                      fontSize: "10px",
                      fontFamily: "var(--font-mono)",
                      color: isActive ? jur.color : "#999999",
                      opacity: isActive ? 0.7 : 1,
                    }}
                  >
                    {count}
                  </span>
                </button>
              );
            })}
          </nav>

          {activeView === "feed" && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                paddingBottom: "8px",
              }}
            >
              <button
                onClick={() => onFetch("daily")}
                disabled={searchBusy}
                style={{
                  padding: "7px 18px",
                  borderRadius: "4px",
                  border: `1.5px solid ${jurColor}`,
                  backgroundColor: jurColor,
                  color: "#fff",
                  fontSize: "12px",
                  fontFamily: "var(--font-sans)",
                  fontWeight: 600,
                  cursor: searchBusy ? "not-allowed" : "pointer",
                  opacity: searchBusy ? 0.6 : 1,
                }}
              >
                {loading
                  ? "Searching\u2026"
                  : classifying
                    ? "Classifying\u2026"
                    : saving
                      ? "Saving\u2026"
                      : "Daily Search"}
              </button>
              <button
                onClick={() => onFetch("deep")}
                disabled={searchBusy}
                style={{
                  padding: "7px 14px",
                  borderRadius: "4px",
                  border: "1.5px solid #999",
                  backgroundColor: "#fff",
                  color: "#70706E",
                  fontSize: "12px",
                  fontFamily: "var(--font-sans)",
                  fontWeight: 500,
                  cursor: searchBusy ? "not-allowed" : "pointer",
                  opacity: searchBusy ? 0.6 : 1,
                }}
              >
                Deep Search
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
